import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface ICreateExtractTasksWithExtraArgsParams {
  targetType: string; // ExtractTaskTargetType
  targetIds: string[];
  scheduleId: string;
  type: string; // ExtractTaskType
  level: string;
  startingItems: string[];
}

export class CreateExtractTasksWithExtraArgsRequest extends Request<ICreateExtractTasksWithExtraArgsParams, IResult> {
  constructor(params: ICreateExtractTasksWithExtraArgsParams) {
    super('createExtractTasksWithExtraArgs', params);
  }
}
